import { MobilePhonePaymentQuestion } from '@hb/domain/steps/financial-obligation';
import { MobilePhonePaymentStoreService } from '@hb/modules/financial-obligations/mobile-phone-payment/mobile-phone-payment-store.service';
import { PreviousButtonComponent } from '@hb/modules';
import { MobilePhonePaymentAmountComponent } from '@hb/modules/financial-obligations/mobile-phone-payment/mobile-phone-amount/mobile-phone-payment-amount.component';

import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { ApContentPipe } from '@ap/content';

@Component({
    selector: 'mobile-phone-payment',
    templateUrl: './mobile-phone-payment.component.html',
    imports: [PreviousButtonComponent, ApContentPipe, MobilePhonePaymentAmountComponent],
    styleUrls: ['../../global/global.scss']
})
export class MobilePhonePaymentComponent implements OnInit, OnDestroy {
    protected readonly store = inject(MobilePhonePaymentStoreService);

    protected activeQuestion: MobilePhonePaymentQuestion;
    private activeQuestionSubscription: Subscription;

    ngOnInit(): void {
        this.activeQuestionSubscription = this.store
            .getActiveQuestion()
            .subscribe((activeQuestion) => (this.activeQuestion = activeQuestion));
    }

    ngOnDestroy() {
        this.activeQuestionSubscription.unsubscribe();
    }

    previousQuestion(): void {
        this.store.backQuestion();
    }

    showMobilePhonePaymentAmount(): boolean {
        return (
            this.activeQuestion === MobilePhonePaymentQuestion.AMOUNT ||
            (this.store.isActiveQuestion(MobilePhonePaymentQuestion.AMOUNT) && this.store.isSummary)
        );
    }
}
